// The backend's user_type values are not the nav's keys. 'fleetmanager' never
// matched `fleet_manager`, so fleet managers were silently given the car-owner
// nav (no link to /fleet at all); 'consumer' only reached the car-owner nav by
// that same fallback. Map once, here, for Sidebar and BottomTabs.
// Only the four types registration and admin actually create; anything else
// keeps the car-owner fallback it always had.
const NAV_ROLE = {
  consumer: 'car_owner',
  fleetmanager: 'fleet_manager',
  mechanic: 'mechanic',
  admin: 'admin',
};

export function navRoleFor(userType) {
  return NAV_ROLE[userType] || 'car_owner';
}

// Fleet pages are scoped by id (/fleet/:fleetId/vehicles, …/reports). The
// nav once linked '/fleet/vehicles', which FleetRoutes reads as a fleet whose
// id is "vehicles". Fleet entries are written 'fleet:<suffix>' and resolved
// against the fleet in view; with no fleet yet, they lead to /fleet, where
// one is created or picked.
export function resolveFleetLink(to, fleetId) {
  if (!to.startsWith('fleet:')) return to;
  if (!fleetId) return '/fleet';
  return `/fleet/${fleetId}${to.slice('fleet:'.length)}`;
}
